import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";

var _class, _descriptor, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { observable, runInAction } from "mobx";
import { BaseOptions } from "@tatum/utils";
var OptionStore = (_class = (_temp = /*#__PURE__*/function (_BaseOptions) {
  _inherits(OptionStore, _BaseOptions);

  var _super = _createSuper(OptionStore);

  // Implement "others" property in your Assets.php;
  function OptionStore(rootStore) {
    var _this;

    _classCallCheck(this, OptionStore);

    _this = _super.call(this);

    _initializerDefineProperty(_this, "others", _descriptor, _assertThisInitialized(_this));

    _this.pureSlug = void 0;
    _this.pureSlugCamelCased = void 0;
    _this.rootStore = void 0;
    _this.rootStore = rootStore;
    _this.pureSlug = BaseOptions.getPureSlug(process.env);
    _this.pureSlugCamelCased = BaseOptions.getPureSlug(process.env, true); // Use the localized WP object to fill this object values.

    runInAction(function () {
      return Object.assign(_assertThisInitialized(_this), window[_this.pureSlugCamelCased]);
    });
    return _this;
  }

  return OptionStore;
}(BaseOptions), _temp), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "others", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
})), _class);
export { OptionStore };